<template>
    <div class="favorite-page" v-if="pageSetup != null">
        <div class="container">
            <div class="section-title-new title-center">
                <h1>{{ pageSetup.page_title }}</h1>
            </div>
            <div class="favorite-navigation">
                <ul>
                    <li>
                       <router-link :to="{ name : 'favorite-projects' }" class="nav-link">ЖИЛЫЕ КОМПЛЕКСЫ</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name : 'favorite-flats' }" class="nav-link">квартиры</router-link>
                    </li>
                </ul>
            </div>
            <div class="favorite-page-inner">
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <router-view />
                </transition>
            </div>
        </div>
        <formPage></formPage>
    </div>
</template>

<script>
	import formPage from '@/components/forms/form-page.vue';	
    import {mapGetters} from 'vuex'
    export default {
        name: 'favorite--page',
        components: {
            formPage,
        },
        data () {
            return {
                title: 'Избранное',
            }
        },
        computed: mapGetters({
            pageSetup: 'loadFavoritePage',
        }),
        methods: {
        },
        beforeCreate() {
            this.$store.dispatch('getFavoritePage');
            document.body.dataset.page = 'favorite-page';
        },
        created () {
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/favorite/favorite-page.scss';
    @import '@/styles/respond/favorite/favorite-page-respond.scss';
</style>